/** @type {Map<string, CanvasPattern>} */
const patternCache = new Map();

/**
 * Build a repeating diagonal hatch CanvasPattern for OpenLayers fills.
 *
 * @param {string} lineColor
 * @param {string} backgroundColor
 * @param {{ size?: number, lineWidth?: number }} [options]
 * @returns {CanvasPattern}
 */
export function createHatchPattern(lineColor, backgroundColor, options = {}) {
    const size = options.size ?? 10;
    const lineWidth = options.lineWidth ?? 2.5;
    const key = `${lineColor}|${backgroundColor}|${size}|${lineWidth}`;

    if (patternCache.has(key)) {
        return patternCache.get(key);
    }

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = size;
    canvas.height = size;

    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, size, size);

    ctx.strokeStyle = lineColor;
    ctx.lineWidth = lineWidth;
    ctx.lineCap = 'square';

    ctx.beginPath();
    ctx.moveTo(0, size);
    ctx.lineTo(size, 0);
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(-size * 0.5, size * 0.5);
    ctx.lineTo(size * 0.5, -size * 0.5);
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(size * 0.5, size * 1.5);
    ctx.lineTo(size * 1.5, size * 0.5);
    ctx.stroke();

    const pattern = ctx.createPattern(canvas, 'repeat');
    patternCache.set(key, pattern);
    return pattern;
}

/**
 * @param {string} lineColor
 * @param {string} backgroundColor
 * @param {{ size?: number, lineWidth?: number }} [options]
 */
export function hatchFillColor(lineColor, backgroundColor, options) {
    return createHatchPattern(lineColor, backgroundColor, options);
}
